import { CurrencySEOMarkdown } from "../CurrencySEOMarkdown";

export default function Benefits({ currencyData }: any) {
  return (
    <>
      <div className="separator"></div>
      <h2 className="h2">{currencyData?.benefits?.title}</h2>
      <CurrencySEOMarkdown className="description mt10">
        {currencyData?.benefits?.sub_title}
      </CurrencySEOMarkdown>
      <ul className="benifitsList">
        {currencyData?.benefits?.list?.map((item: any, index: number) => (
          <li key={index}>
            <CurrencySEOMarkdown>{item}</CurrencySEOMarkdown>
          </li>
        ))}
      </ul>
      <CurrencySEOMarkdown className="description">
        {currencyData?.benefits?.end_para}
      </CurrencySEOMarkdown>
    </>
  );
}
